import { useEffect } from 'react';
export default function DemoOverlay({ name, language = 'pt' }: { name: string; language?: 'pt' | 'en' }) {
  useEffect(() => {
    let alive = true;
    const mount = () => { if (alive) document.dispatchEvent(new CustomEvent('maincode-demo:mount', { detail: { name, slug: window.location.pathname, language } })); };
    let script = document.getElementById('maincode-demo-script') as HTMLScriptElement | null;
    if (!script) { script = document.createElement('script'); script.id = 'maincode-demo-script'; script.src = '/demo-assets/maincode-demo.js?v=6'; script.onload = () => { script!.dataset.ready = 'true'; mount(); }; document.body.append(script); }
    else if (script.dataset.ready) mount(); else script.addEventListener('load', mount, { once: true });
    return () => { alive = false; script?.removeEventListener('load', mount); document.dispatchEvent(new Event('maincode-demo:unmount')); };
  }, [name, language]);
  return null;
}
